module.exports = __webpack_public_path__ + "img/productlb3.90b4d392.png";